import { defineAction } from '~/prix'
import apiKeyGenerateAction from './apiKeyGenerate.action.json' with { type: 'json' }
import { z } from 'zod'

const apiKeyGenerateDefinition = defineAction({
  ...apiKeyGenerateAction,

  input: z
    .object({
      userId: z.number().nullish(),
      dataSourceId: z.number().nullish(),
      force: z.boolean().default(false),
    })
    .refine(data => Boolean(data.userId) !== Boolean(data.dataSourceId), {
      message: 'Informe apenas userId ou dataSourceId, não ambos ou nenhum',
      path: ['userId', 'dataSourceId'],
    }),
  output: z.object({
    id: z.number(),
    secret: z.string(),
    createdAt: z.string(),
  }),
})

export default apiKeyGenerateDefinition
